"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HankTextarea = exports.TextArea = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("./form/utils");
var spacing_1 = require("./spacing");
var TextAreaStyle = (0, styled_components_1.default)(spacing_1.Div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  textarea {\n    ", "\n    line-height: 150%;\n  }\n"], ["\n  textarea {\n    ", "\n    line-height: 150%;\n  }\n"])), utils_1.inputStyle);
var TextArea = function (_a) {
    var _b = _a.styledProps, styledProps = _b === void 0 ? {} : _b, nativeProps = _a.nativeProps;
    return (react_1.default.createElement(TextAreaStyle, __assign({}, styledProps),
        react_1.default.createElement("textarea", __assign({}, nativeProps))));
};
exports.TextArea = TextArea;
exports.HankTextarea = react_1.default.forwardRef(function (_a, ref) {
    var _b = _a.styledProps, styledProps = _b === void 0 ? {} : _b, nativeProps = __rest(_a, ["styledProps"]);
    return (react_1.default.createElement(TextAreaStyle, __assign({}, styledProps),
        react_1.default.createElement("textarea", __assign({ ref: ref }, nativeProps))));
});
var templateObject_1;
//# sourceMappingURL=TextArea.js.map